import React from 'react';
import PropTypes from 'prop-types';

import { LoadablePaint, LoadableLazy } from '@confluence/loadable';
import { PageSegmentLoadStart } from '@confluence/browser-metrics/entry-points/PageSegmentLoadStart.ts';
import { useSubmitSSRScriptErrors } from '@confluence/ssr-scripts-utils/entry-points/useSubmitSSRScriptErrors.ts';

import { WATCH_BUTTON_METRIC } from '../src/perf.config.js';
import { WatchButtonPlaceholder } from '../src/WatchButtonPlaceholder.js';

export const LazyDialogWrapperLoader = LoadableLazy<any>({
	loader: async () =>
		(await import(/* webpackChunkName: "loadable-watch-dialog" */ '../src/WatchDialogWrapper.js'))
			.WatchDialogWrapper,
	loading: WatchButtonPlaceholder,
});
export const WatchDialogWrapperLoader = LoadablePaint<any>({
	loader: async () =>
		(await import(/* webpackChunkName: "loadable-watch-dialog" */ '../src/WatchDialogWrapper.js'))
			.WatchDialogWrapper,
	loading: WatchButtonPlaceholder,
});
export const WatchDialogWrapper = (props) => {
	useSubmitSSRScriptErrors('page-watch-button');
	return (
		<>
			<PageSegmentLoadStart key={props.contentId} metric={WATCH_BUTTON_METRIC} />
			<WatchDialogWrapperLoader {...props} />
		</>
	);
};

WatchDialogWrapper.propTypes = {
	contentId: PropTypes.string,
	defaultTab: PropTypes.number,
	componentLocation: PropTypes.number,
};
